/**
 * Utilidades de formateo para números, monedas y porcentajes en el módulo de KPIs.
 */

export function formatCOP(val: number | null | undefined): string {
  if (val === null || val === undefined || isNaN(val)) return '$0';
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(val);
}

export function formatCOPShort(val: number | null | undefined): string {
  if (val === null || val === undefined || isNaN(val)) return '$0';
  const abs = Math.abs(val);
  const sign = val < 0 ? '-' : '';

  if (abs >= 1_000_000_000) {
    return `${sign}$${(abs / 1_000_000_000).toFixed(1).replace('.0', '')} B`;
  }
  if (abs >= 1_000_000) {
    return `${sign}$${(abs / 1_000_000).toFixed(1).replace('.0', '')} M`;
  }
  if (abs >= 1_000) {
    return `${sign}$${(abs / 1_000).toFixed(0)} mil`;
  }
  return `${sign}$${abs.toLocaleString('es-CO')}`;
}

export function formatPct(val: number | null | undefined, includeSign = true): string {
  if (val === null || val === undefined || isNaN(val)) return '0%';
  const sign = includeSign && val > 0 ? '+' : '';
  return `${sign}${val.toFixed(1)}%`;
}

export function formatNumber(val: number | null | undefined): string {
  if (val === null || val === undefined || isNaN(val)) return '0';
  return new Intl.NumberFormat('es-CO').format(val);
}
